// third-party
import { Trans } from 'react-i18next';

// assets
import {
    IconBrandChrome,
    IconHelp,
    IconSitemap,
    IconHome,
    IconDashboard,
    IconChartBar,
    IconTrophy,
    IconFlag,
    IconShoppingCart,
    IconWallet,
    IconCalendar,
    IconDownload,
    IconBook,
    IconCertificate
} from '@tabler/icons';
import IconFactCheckOutlined from '@mui/icons-material/FactCheckOutlined';
import { NavItemType } from 'types';

// constant
const icons = {
    IconBrandChrome,
    IconHelp,
    IconSitemap,
    IconHome,
    IconDashboard,
    IconChartBar,
    IconTrophy,
    IconFlag,
    IconShoppingCart,
    IconWallet,
    IconCalendar,
    IconDownload,
    IconBook,
    IconFactCheckOutlined,
    IconCertificate
};
// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const other: NavItemType = {
    id: 'main-navigation',
    type: 'group',
    children: [
        {
            id: 'home',
            title: <Trans>home</Trans>,
            type: 'item',
            url: '/home',
            icon: icons.IconHome,
            breadcrumbs: false
        },
        {
            id: 'dashboard',
            title: <Trans>dashboard</Trans>,
            type: 'item',
            url: '/dashboard',
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'analysis-hub',
            title: <Trans>analysis_hub_section.title</Trans>,
            type: 'item',
            url: '/analysis-hub',
            icon: icons.IconChartBar,
            breadcrumbs: false
        },
        // {
        //     id: 'leaderboard',
        //     title: <Trans>leaderboard</Trans>,
        //     type: 'item',
        //     url: '/leaderboard',
        //     icon: icons.IconTrophy,
        //     breadcrumbs: false
        // },
        // {
        //     id: 'competitions',
        //     title: <Trans>competitions</Trans>,
        //     type: 'item',
        //     url: '/competitions',
        //     icon: icons.IconFlag,
        //     breadcrumbs: false
        // },
        {
            id: 'orders',
            title: <Trans>orders</Trans>,
            type: 'item',
            url: '/orders',
            icon: icons.IconShoppingCart,
            breadcrumbs: false
        },
        {
            id: 'withdrawals',
            title: <Trans>withdrawals</Trans>,
            type: 'item',
            url: '/withdrawals',
            icon: icons.IconWallet,
            breadcrumbs: false
        },
        {
            id: 'calendar',
            title: <Trans>calendar</Trans>,
            type: 'item',
            url: '/calendar',
            icon: icons.IconCalendar,
            breadcrumbs: false
        },
        {
            id: 'downloads',
            title: <Trans>downloads_section.title</Trans>,
            type: 'item',
            url: '/downloads',
            icon: icons.IconDownload,
            breadcrumbs: false
        },
        {
            id: 'rules',
            title: <Trans>rules</Trans>,
            type: 'item',
            url: '/rules',
            icon: icons.IconBook,
            breadcrumbs: false
        },
        {
            id: 'kyc',
            title: <Trans>kyc</Trans>,
            type: 'item',
            url: '/kyc',
            icon: icons.IconFactCheckOutlined,
            breadcrumbs: false
        },
        {
            id: 'certificates',
            title: <Trans>certificates_section.title</Trans>,
            type: 'item',
            url: '/certificates',
            icon: icons.IconCertificate,
            breadcrumbs: false
        }
    ]
};

export default other;
